import {useField, useForm} from "vee-validate";
import * as yup from 'yup'

export function useRequestForm(fn, fio, document, mobile) {
    const {isSubmitting, handleSubmit} = useForm({
        initialValues: {
            name: fio,
            phone: mobile,
            contract: document,
        }
    })

    const {value: name, errorMessage: nError, handleBlur: nBlur} = useField('name',
        yup.string()
            .trim()
            .required('Введите ФИО')
    ) //
    const {value: phone, errorMessage: pError, handleBlur: pBlur} = useField('phone',
        yup.string()
            .trim()
            .required('Введите телефон')
    )
    const {value: contract, errorMessage: cError, handleBlur: cBlur} = useField('contract',
        yup.string()
            .required('Введите номер договора')
    )
    const {value: message, errorMessage: mError, handleBlur: mBlur} = useField('message',
        yup.string()
            .trim()
            .required('Оставьте ваш комментарий')
    )

    const requestSubmit = handleSubmit(fn)

    return {
        isSubmitting,
        requestSubmit,
        name,
        phone,
        contract,
        message,
        nError,
        nBlur,
        pError,
        pBlur,
        cError,
        cBlur,
        mError,
        mBlur
    }
}